// Betohalics platform contract version. Games record the version they were
// built against (exposed as platform.contractVersion). See ../CONTRACTS.md.
export const PLATFORM_CONTRACT_VERSION = '1.0.0';
